var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.003,
    viewBox: "0 0 16 16.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#597dff",
    d: "M-316.776-11074.889h-5.335a.89.89,0,0,1-.888-.89v-5.333a.89.89,0,0,1,.888-.891h5.335a.89.89,0,0,1,.888.891v5.333A.89.89,0,0,1-316.776-11074.889Zm-4.445-5.336v3.559h3.555v-3.559Z",
    transform: "translate(322.999 11082.002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#597dff",
    d: "M-316.776-11074.889h-5.335a.89.89,0,0,1-.888-.89v-5.333a.89.89,0,0,1,.888-.891h5.335a.89.89,0,0,1,.888.891v5.333A.89.89,0,0,1-316.776-11074.889Zm-4.445-5.336v3.559h3.555v-3.559Z",
    transform: "translate(331.888 11082.002)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#597dff",
    d: "M-316.776-11074.889h-5.335a.89.89,0,0,1-.888-.89v-5.333a.89.89,0,0,1,.888-.891h5.335a.89.89,0,0,1,.888.891v5.333A.89.89,0,0,1-316.776-11074.889Zm-4.445-5.336v3.559h3.555v-3.559Z",
    transform: "translate(322.999 11090.892)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    transform: "translate(8.889 8.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(3.556)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(1.778 1.778)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(5.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(3.556 2.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(1.778 5.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(0 5.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(5.334 4.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(5.334 5.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#597dff",
    width: 1.778,
    height: 1.778,
    transform: "translate(0 3.556)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.fb76dde93e598126d9cecf779806c3ca.svg";
export { ForwardRef as ReactComponent };